import React from 'react';
import { Helmet } from 'react-helmet-async';
import DeviationMediaService from '../../../utils/DeviationMediaService';
export var PdfFullView = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height;
    var pdfFiles = DeviationMediaService.getMediaByType(deviation, 'pdf');
    if (!pdfFiles || pdfFiles.length === 0) {
        return null;
    }
    var pdfFile = pdfFiles.pop();
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("link", { rel: "preload", href: pdfFile.src, as: "object" })),
        React.createElement("object", { "aria-label": deviation.title, data: pdfFile.src, style: { width: width, height: height }, type: "application/pdf" })));
};
export default PdfFullView;
//# sourceMappingURL=Pdf.js.map